export const testIds = {
  mhhsLoadingCard: 'mhhs-loading-card',
};
